import React, { useEffect } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { setAuthorization } from '../helpers/api_helper';
import { useProfile } from '../Components/Hooks/UserHooks';
import SessionMonitor from '../Components/Common/SessionMonitor';
import { PermissionProvider } from '../contexts/PermissionContext';

const AuthProtected = props => {
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    }
  }, [token, userProfile, loading]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className='d-flex justify-content-center align-items-center min-vh-100'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  /*
    Navigate is un-auth access protected routes via url
    */
  if (!userProfile && !loading && !token) {
    return (
      <Navigate to={{ pathname: '/login', state: { from: props.location } }} />
    );
  }

  return (
    <PermissionProvider>
      <SessionMonitor />
      {props.children}
    </PermissionProvider>
  );
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (
          <>
            {' '}
            <Component {...props} />{' '}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
